import { articleTemplateApi } from '@/axios/articleTemplate';
import PaginationSelector from './PaginationSelector';

type Params = Omit<Parameters<typeof articleTemplateApi.list>[0], 'pageIndex' | 'pageSize'>;

// 提取 records 数组元素的类型
type TaskRecord = Awaited<ReturnType<typeof articleTemplateApi.list>>['records'][number];

/** 用户选择器 */
const ArticleTemplateSelector = ({
  params,
  placeholder = '请选择发文模板',
  value,
  onChange,
  multiple = false,
}: {
  params?: Omit<Parameters<typeof articleTemplateApi.list>[0], 'pageIndex' | 'pageSize'>;
  placeholder?: string;
  value?: string | string[];
  onChange?: (value: string | string[]) => void;
  multiple?: boolean;
}) => {
  return (
    <PaginationSelector<TaskRecord, Params>
      fetchApi={(params) => articleTemplateApi.list(params)}
      params={params}
      optionTransform={(item) => ({
        value: item.templateId,
        label: item.templateName,
      })}
      searchParamKey='templateName'
      placeholder={placeholder}
      value={value}
      onChange={onChange}
      multiple={multiple}
    />
  );
};
export default ArticleTemplateSelector;
